import React, {useState, useEffect} from 'react';
import Modal from "./Modal";
import {SalaryBonusPenaltyType, SalaryBonusPenaltyCreate, SalaryBonusPenaltyUpdate} from "../../models/SalaryBonusPenalty";

interface SalaryBonusPenaltyModalProps {
  show: boolean;
  onClose: () => void;
  onSave: (data: SalaryBonusPenaltyCreate | SalaryBonusPenaltyUpdate, id?: number) => void;
  editing?: SalaryBonusPenaltyType | null;
}

const SalaryBonusPenaltyModal: React.FC<SalaryBonusPenaltyModalProps> = (props) => {
  const [type, setType] = useState<'bonus' | 'penalty'>('bonus');
  const [amount, setAmount] = useState<number>(0);
  const [reason, setReason] = useState<string>('');
  const [date, setDate] = useState<string>('');

  useEffect(() => {
    if (props.editing) {
      setType(props.editing.type);
      setAmount(props.editing.amount);
      setReason(props.editing.reason || '');
      setDate(props.editing.date);
    } else {
      setType('bonus');
      setAmount(0);
      setReason('');
      setDate(new Date().toISOString().split('T')[0]);
    }
  }, [props.editing, props.show]);

  const handleSave = () => {
    if (props.editing) {
      const data: SalaryBonusPenaltyUpdate = {};
      if (amount !== props.editing.amount) data.amount = amount;
      if (reason !== (props.editing.reason || '')) data.reason = reason;
      if (date !== props.editing.date) data.date = date;
      props.onSave(data, props.editing.id);
    } else {
      const data: SalaryBonusPenaltyCreate = {type, amount, reason, date};
      props.onSave(data);
    }
  };

  return (
    <Modal
      id="salary-bonus-penalty"
      title={props.editing ? 'Редактировать' : 'Добавить'}
      show={props.show}
      onClose={props.onClose}
      footerButtons={<button className="btn bg-gradient-success" onClick={handleSave}>Сохранить</button>}
    >
      {!props.editing && (
        <div className="form-group">
          <label>Тип</label>
          <select className="form-control" value={type} onChange={(e) => setType(e.target.value as 'bonus' | 'penalty')}>
            <option value="bonus">Премия</option>
            <option value="penalty">Штраф</option>
          </select>
        </div>
      )}
      <div className="form-group">
        <label>Сумма</label>
        <input
          type="number"
          className="form-control"
          value={amount}
          onChange={(e) => setAmount(parseInt(e.target.value) || 0)}
        />
      </div>
      <div className="form-group">
        <label>Причина</label>
        <input
          type="text"
          className="form-control"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Дата</label>
        <input
          type="date"
          className="form-control"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>
    </Modal>
  );
};

export default SalaryBonusPenaltyModal;